import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { motion } from "framer-motion";
import whitePaperPDF from "../assets/docs/ucwaves_white_paper.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Whitepaper = () => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    let aborted = false;
    let objectUrl: string | null = null;

    const loadPdf = async () => {
      try {
        const response = await fetch(whitePaperPDF);
        if (!response.ok)
          throw new Error(`Failed to fetch PDF: ${response.statusText}`);
        const blob = await response.blob();
        if (aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(objectUrl);
      } catch (err) {
        console.error("Error loading PDF:", err);
      }
    };

    loadPdf();

    return () => {
      aborted = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToPrevPage = () => pageNumber > 1 && setPageNumber(pageNumber - 1);
  const goNAUNextPage = () =>
    pageNumber < numPages && setPageNumber(pageNumber + 1);
  return (
    <div
      id="whitepaper-section"
      className="flex flex-col items-center px-4 py-10"
    >
      <h2 className="text-2xl font-bold text-gray-800 mb-3">
        UC Waves Whitepaper
      </h2>

      <div className="mb-4">
        <a
          href={`${window.location.origin}/docs/ucwaves_white_paper.pdf`}
          download="ucwaves_white_paper.pdf"
          className="inline-block px-4 py-2 bg-black text-white hover:bg-gray-800 transition text-sm"
        >
          Download Whitepaper (PDF)
        </a>
      </div>

      {pdfBlobUrl ? (
        <div className="w-full max-w-3xl border border-gray-200 shadow-lg overflow-hidden">
          <Document
            file={pdfBlobUrl}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages);
              setPageNumber(1);
            }}
            onLoadError={(error) => {
              console.error("PDF load error:", error?.message || error);
            }}
            loading={
              <p className="text-center py-8 text-gray-500">Loading PDF…</p>
            }
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Page
                pageNumber={pageNumber}
                width={Math.min(800, windowWidth - 32)}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </motion.div>
          </Document>
        </div>
      ) : (
        <p className="text-center py-8 text-gray-500">Loading PDF…</p>
      )}

      {numPages > 0 && (
        <div className="flex items-center gap-4 mt-6">
          <button
            onClick={goToPrevPage}
            disabled={pageNumber <= 1}
            className={`px-3 py-1.5 w-30 text-sm ${
              pageNumber <= 1
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-black text-white hover:bg-red-900"
            }`}
          >
            ← Previous
          </button>

          <span className="text-gray-700 text-sm">
            Page {pageNumber} / {numPages}
          </span>

          <button
            onClick={goNAUNextPage}
            disabled={pageNumber >= numPages}
            className={`px-3 py-1.5 w-30 text-sm ${
              pageNumber >= numPages
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-black text-white hover:bg-red-900"
            }`}
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default Whitepaper;
